import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ExportTypeDropdown } from '../../../models/influencer-export';
import { ExportOptionsInit } from '../../app.constants';
import { ExportInfluencerService } from '../services/export-influencer.service';
import { NewInfluencerGroup } from '../../../models/auto-group/auto-group-setting';
import { apiEndpoints } from '../../app.constants';

@Component({
  selector: 'export-influencer',
  templateUrl: './export-influencer.component.html',
  styleUrls: ['./export-influencer.component.scss'],
  encapsulation: ViewEncapsulation.Emulated // or None or ShadowDom
})
export class ExportInfluencerComponent implements OnInit {

  @Input() componentId: string = '' + Math.floor(Math.random() * Math.pow(10, 17)) + new Date().getTime();
  @Input() label: 'Export';
  @Input() influencerGroup: NewInfluencerGroup;
  @Input() campaignId: number;
  public exportOptions: Array<ExportTypeDropdown> = ExportOptionsInit;
  public exportValue: string = this.exportOptions[0].id;
  public isExportLoading = false;
  private exportProps: {url: string};

  constructor(private exportService: ExportInfluencerService) { }

  ngOnInit() {
    this.exportProps = this.handleExportProps();
  }

  private handleExportProps() {
    if (this.campaignId) {
      return {url: apiEndpoints.exportInfluencerCampaign.replace(':campaignId', '' + this.campaignId)};
    }

    if (this.influencerGroup) {
      return {url: apiEndpoints.exportInfluencerGroup.replace(':groupId', '' + this.influencerGroup.id)};
    }

    return {url: ''};
  }

  public export(format = 'excel') {
    this.exportService.exportInfluencer(
      {format: format.toLocaleLowerCase() === 'pdf' ? 'pdf' : 'excel'},
      this.exportProps,
      this.label,
      this.setExportLoading.bind(this)
    );
  }

  public setExportLoading(isLoading = false) {
    this.isExportLoading = isLoading;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/export-influencer/export-influencer.component.ts